import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import MyAppText from '../MyAppText';
import { translate } from '../../services/translate';
import { faCalculator, faCalendarCheck, faLocationDot, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { WindowInformation } from '../../services/window-information';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Card from '../Card';
import { RootNavigation } from '../../Routes';

export function AlarmCenterOccurrence({ occurrence, navigation }: { occurrence: Occurrence; navigation: RootNavigation; }) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    if (occurrence.triggerType !== 'alarm_center') {
        return <></>;
    }

    return (
        <View style={{ gap: 20 }}>
            <View style={{ gap: 5 }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <TouchableOpacity
                            onPress={() => {
                                window.open(`/dispatch/occurrences/detail/${occurrence?.id}`);
                            }}
                            disabled={windowInfo.isMobile}
                        >
                            <MyAppText style={{ fontSize: 16, color: theme.colors.labelColor, fontWeight: 'bold' }}>
                                {translate('nProtocol')}: {occurrence?.id}
                            </MyAppText>
                        </TouchableOpacity>
                        <MyAppText> </MyAppText>
                        <MyAppText style={{ fontSize: 14, color: theme.colors.card.detailText }}>
                            ({translate('team')} {translate(occurrence.OccurrenceUnits?.length && occurrence.OccurrenceUnits[0].OccurrenceUnit.isStarter ? 'starter' : 'support').toLowerCase()})
                        </MyAppText>
                    </View>
                    <TouchableOpacity onPress={() => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' })}>
                        <FontAwesomeIcon color={theme.colors.textColor} fontSize={30} icon={faTimes} />
                    </TouchableOpacity>
                </View>
                <MyAppText style={styles.alertText}>
                    {translate('alarmCenterAlert')}:
                </MyAppText>
            </View>
            <Card>
                <View style={styles.visualizedRow}>
                    <MyAppText style={styles.cardBoldText}>{translate('type')}:</MyAppText>
                    <MyAppText style={styles.cardText}>{translate(occurrence.resume.type)}</MyAppText>
                </View>
                <View style={{ gap: 15 }}>
                    <View style={{ gap: 5 }}>
                        <MyAppText style={styles.cardBoldText}>{translate('visualizedOn')}</MyAppText>
                        <View style={styles.visualizedRow}>
                            <FontAwesomeIcon icon={faCalculator} style={{ color: theme.colors.iconColor }} />
                            <MyAppText style={styles.cardText}>{occurrence.externalReference?.title}</MyAppText>
                        </View>
                        <View style={styles.visualizedRow}>
                            <FontAwesomeIcon icon={faCalendarCheck} style={{ color: theme.colors.iconColor }} />
                            <MyAppText style={styles.cardText}>{moment(occurrence.createdAt).format('DD/MM/YYYY HH:mm:ss')}</MyAppText>
                        </View>
                        <View style={styles.visualizedRow} >
                            <FontAwesomeIcon icon={faLocationDot} style={{ width: 14 }} color={theme.colors.iconColor} />
                            <MyAppText style={styles.cardText}>{occurrence.externalReference?.address}</MyAppText>
                        </View>
                    </View>
                </View>
                <View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('occurrenceId')}:</MyAppText>
                        <MyAppText style={styles.cardText}>{occurrence.id}</MyAppText>
                    </View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('priority')}:</MyAppText>
                        <MyAppText style={[styles.cardText, occurrence.priority === 'maximum' ? { color: '#FF0027' } : undefined]}>{occurrence.priority ? translate(occurrence.priority) : ''}</MyAppText>
                    </View>
                    <View>
                        <View style={{ paddingBottom: 30 }}>
                            <MyAppText style={styles.cardBoldText}>{translate('narrative')}:</MyAppText>
                            <MyAppText style={styles.cardText}>{occurrence.narrative}</MyAppText>
                        </View>
                    </View>
                </View>
            </Card>
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    alertText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        fontWeight: 'bold',
    },
    alertName: {
        color: theme.colors.textColor,
        fontSize: 18,
        fontWeight: 'bold',
        paddingBottom: 8
    },
    visualizedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },
    cardText: {
        color: theme.colors.iconColor,
        fontSize: 12
    },
    cardBoldText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 14
    },
    plateInfoText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 24
    },
    watchVideoText: {
        color: theme.colors.iconColor,
        fontSize: 16,
        textDecorationLine: 'underline'
    }
}));
